import React, { useContext, useEffect, useState } from "react";   //FB 4409 DK - Added useeffect reference
import {
  Grid,
  Avatar,
  Typography,
  makeStyles,
  Link,
  Card,
  CardContent,
  CardMedia,
} from "@material-ui/core";
import doc from "../../../images/JoshuaFox.jpg";
//import { Schedule, Provider } from "../../types";
import SlotsContainer from "./SlotsContainer";
import useStyle from "../css/styles";
import { Context } from "../store";
import { formatphone, GetAdminSettingValue } from "../api";		//FB 4774 DK - Importing formatphone method, FB 7418

// update log
// FB 4371 DK   03/29/2021    Added UI component to display the slots container
// FB 4409 DK   04/27/2021    Implementation of loading spinner on slots page
// FB 4409 DK   04/30/2021    Added message to show when all available slots are booked
// FB 4638 MS   08/31/2021    Fixed Mobile view issues
// FB 4769 MS   11/02/2021    Added Job title Info for provider
// FB 4774 DK   11/24/2021    Message changes
// FB 4867 DK   01/20/2022    Phone number made clickable
// FB 4912 DK   01/27/2022    Resolved message error
// FB 7418 GS   09/21/2023    Added admin setting to change the message on PE when slots are not available
// FB 8680 DK   05/21/2024    Practice phone related changes

export type Schedule = {
  ScheduleDate: string;
  Slots: string[];
};

export type schedulesByLocation = {
  Employee_N: number;
  Employee_First_Name: string;
  Employee_Last_Name: string;
  NextAvailability: string;
  SlotsDate: SlotsDate[];
  isInsuranceAccepted: boolean;
  SchedulinPhone: string;
  Employee_Bio: string;
  availableSlotsCount: number;    //FB 4409 DK - Added variable for available slots count
  Duration: Number;  //FB 4638 Added appointment duration field
  Employee_Job_Title: string;  //FB 4769
};

export type SlotsDate = {
  ScheduleDate: string;
  Slots: string[];
};

export type Provider = {
  //name: string;
  //id: number;
  //facility: Facility;
  schedulesByLocation: schedulesByLocation[];
};

interface ILocationScheduleRowProps {
  Provider: Provider;
  Limited: number;
  Index: number;
  FacilityId: number;
  FacilityName: string;
  isLoading: any;     //FB 4409 DK - Added isLoading flag to activate loading spinner
}

const useStyles = makeStyles((theme) => ({
  flexColumn: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "200px",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  centered: {
    alignSelf: "center",
  },
  content: {
    flex: "1 0 auto",
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  topBarItem: {
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  margin: {
    margin: theme.spacing(1),
  },
  providerRow: {
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    padding: "20px 0",
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    padding: "10px",
    cursor: "pointer",
    fontSize: "smaller",
  },
}));

function LocationScheduleRow(props: ILocationScheduleRowProps) {
  const classes = useStyles();
  const styles = useStyle();
  let Phone = props.Provider.schedulesByLocation[props.Index].SchedulinPhone;
  if (Phone !== null) {
    Phone = Phone.replace(/[^0-9]/g, "");
  } else {
    Phone = "";
  }
  const { state, dispatch } = useContext(Context);
  const [disableEvents, setDiableEvents] = useState(false);
  //FB 7418 Begin
  const [textMessage, setTextMessage] = useState("");
  const [textValue, setTextValue] = useState(false);
  //FB 7418 End

  //FB 4409 DK - Added flag for loading spinner
  const [isLoading, setIsLoading] = useState(false);
  const [defaultPhone, setDefaultPhone] = useState(""); //FB 8680

  //FB 7418 Begin
  async function GetSlotsMessage() {
    var data = await GetAdminSettingValue("PE_Slot_Unavailable_Message");
    if (data != "") {
      setTextMessage(data);
      setTextValue(true);
    }
    //FB 8680
    var practicePhone = await GetAdminSettingValue("Default_Sch_Appt_Number");
    if (practicePhone != null) {
      setDefaultPhone(practicePhone);
    }
  }
  //FB 7418 End

  //FB 4409 DK - Added to swap the isLoading flag on slots page when isLoading flag is updated 
  useEffect(() => {
    GetSlotsMessage(); //FB 7418
    props.isLoading(isLoading);
  }, [isLoading])

  return props.Provider !== undefined ? (
    <div>
      {window.innerWidth <= 768 ? (
        <div>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="center"
          >
            <Grid item xs={12}>
              <Card
                className={styles.slotslocation_Card}
                style={{ boxShadow: "none" }}
              >
                <CardMedia>
                  <Avatar
                    style={{ marginTop: 5 }}
                    className={styles.slotslocation_Avatar}
                    src={
                      "/Images/Providers/" +
                      props.Provider.schedulesByLocation[props.Index]
                        .Employee_N +
                      ".jpg"
                    }
                  />
                </CardMedia>
                <CardContent>
                  <Typography variant="h6">
                    <b>
                      {
                        props.Provider.schedulesByLocation[props.Index]
                          .Employee_First_Name
                      }{" "}
                      {
                        props.Provider.schedulesByLocation[props.Index]
                          .Employee_Last_Name
                      }
                    </b>
                  </Typography>
                  {/* FB 4769 BEGIN */}
                  <Typography style={{ fontSize: "smaller" }}>
                    {
                      props.Provider.schedulesByLocation[props.Index]
                        .Employee_Job_Title
                    }
                  </Typography>
                  {/* FB 4769 END */}
                  <Typography style={{ fontSize: "smaller" }}>
                    {
                      props.Provider.schedulesByLocation[props.Index]
                        .Employee_Bio
                    }
                  </Typography>
                  <Typography
                    //variant="subtitle1"
                    style={{
                      color: "red",
                      display:
                        state.appointmentdetails.isInsuranceExist === "No"
                          ? "none"
                          : props.Provider.schedulesByLocation[props.Index]
                            .isInsuranceAccepted
                            ? "none"
                            : "inline-flex",
                    }}
                  >
                    This provider does not accept the selected insurance.
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "smaller",
                      color: "red",
                      display:
                        state.appointmentdetails.isInsuranceExist === "No"
                          ? "none"
                          : props.Provider.schedulesByLocation[props.Index]
                            .isInsuranceAccepted
                            ? "none"
                            : "inline-flex",
                    }}
                  >
                    (If your insurance plan includes out-of-network coverage,
                    please ignore this warning)
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            direction="row"
            alignContent="center"
            justify="center"
            style={{
              display: "flex",
              pointerEvents: disableEvents ? "none" : "auto",
            }}
          >
            {props.Provider.schedulesByLocation[props.Index].NextAvailability
              != null && props.Provider.schedulesByLocation[props.Index].availableSlotsCount <= 0 ? (  //FB 4638 added condtion to check of slots are available
              <Grid
                item
                xs={10}
                style={{ backgroundColor: "lightgray", borderRadius: "16px" }}
              >
                {/* <div className={classes.timeSlotItem}> */}
                <Typography variant="subtitle2" style={{ textAlign: "center" }}>
                  {/*FB 4774 DK - Modified message*/}
                  {/*FB-4867*/} {/*FB-4912*/}
                  The next available online appointment for this provider is {props.Provider.schedulesByLocation[props.Index].NextAvailability}
                  . If you need an appointment sooner, Please call {formatphone(props.Provider.schedulesByLocation[props.Index].SchedulinPhone)}.
                </Typography>
                {/* </div> */}
              </Grid>
              // FB 4409 DK - Added condition and message to be displayed when there are no available slots - Start
            ) : props.Provider.schedulesByLocation[props.Index].availableSlotsCount <= 0 ? (<Grid
              item
              xs={10}
              style={{ backgroundColor: "lightgray", borderRadius: "16px" }}
            >
              {/* <div className={classes.timeSlotItem}> */}
              <Typography variant="subtitle2" style={{ textAlign: "center" }}>
                {/*FB 4774 DK - Modified message*/}
                {/*FB-4867*/} {/*FB-4912*/}
                The next available online appointment for this provider is {props.Provider.schedulesByLocation[props.Index].NextAvailability}
                . If you need an appointment sooner, Please call {formatphone(props.Provider.schedulesByLocation[props.Index].SchedulinPhone)}.
              </Typography>
              {/* </div> */}
            </Grid>
            ) : (
              // FB 4409 DK - Added condition and message to be displayed when there are no available slots - End
              <Grid item xs={10} style={{ overflowX: "auto" }}>
                {props.Provider.schedulesByLocation[props.Index].SlotsDate.map(
                  (ele: SlotsDate, index: number) => (
                    <SlotsContainer
                      limited={props.Limited}
                      schedulesTest={ele}
                      key={index}
                      employeeName={
                        props.Provider.schedulesByLocation[props.Index]
                          .Employee_First_Name +
                        " " +
                        props.Provider.schedulesByLocation[props.Index]
                          .Employee_Last_Name
                      }
                      employeeid={
                        props.Provider.schedulesByLocation[props.Index]
                          .Employee_N
                      }
                      facilityid={props.FacilityId}
                      facilityName={props.FacilityName}
                      facilityPhone={
                        Phone === ""
                          ? ""
                          : "(" +
                          Phone.slice(0, 3) +
                          ") " +
                          Phone.slice(3, 6) +
                          "-" +
                          Phone.slice(6, 10)
                      }
                      onCallback={setDiableEvents}
                      isLoading={setIsLoading}  //FB 4409 DK - Added to update the isLoading flag on slots page
                      duration={props.Provider.schedulesByLocation[props.Index].Duration} //FB 4638 added appt duration
                    />
                  )
                )}
              </Grid>
            )}
          </Grid>
        </div>
      ) : (
        <Grid
          container
          spacing={3}
          direction="row"
          alignContent="center"
          justify="flex-start"
          style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)", marginTop: 10 }}
        >
          <Grid item xs={4} sm={4} md={4}>
            <Card
              className={styles.slotslocation_Card}
              style={{ boxShadow: "none", alignItems: "center" }}
            >
              <CardMedia>
                <Avatar
                  style={{ marginTop: 5 }}
                  className={styles.slotslocation_Avatar}
                  src={
                    "/Images/Providers/" +
                    props.Provider.schedulesByLocation[props.Index].Employee_N +
                    ".jpg"
                  }
                />
              </CardMedia>
              <CardContent style={{ display: "contents" }}>
                <Typography variant="h6">
                  <b>
                    {
                      props.Provider.schedulesByLocation[props.Index]
                        .Employee_First_Name
                    }{" "}
                    {
                      props.Provider.schedulesByLocation[props.Index]
                        .Employee_Last_Name
                    }
                  </b>
                </Typography>
                {/* FB 4769 BEGIN */}
                <Typography style={{ fontSize: "smaller" }}>
                  {props.Provider.schedulesByLocation[props.Index].Employee_Job_Title}
                </Typography>
                {/* FB 4769 END */}
                <Typography style={{ fontSize: "smaller" }}>
                  {props.Provider.schedulesByLocation[props.Index].Employee_Bio}
                </Typography>
                <Typography
                  //variant="subtitle1"
                  style={{
                    color: "red",
                    display:
                      state.appointmentdetails.isInsuranceExist === "No"
                        ? "none"
                        : props.Provider.schedulesByLocation[props.Index]
                          .isInsuranceAccepted
                          ? "none"
                          : "inline-flex",
                  }}
                >
                  This provider does not accept the selected insurance.
                </Typography>
                <Typography
                  style={{
                    fontSize: "smaller",
                    color: "red",
                    display:
                      state.appointmentdetails.isInsuranceExist === "No"
                        ? "none"
                        : props.Provider.schedulesByLocation[props.Index]
                          .isInsuranceAccepted
                          ? "none"
                          : "inline-flex",
                  }}
                >
                  (If your insurance plan includes out-of-network coverage,
                  please ignore this warning)
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            xs={6}
            sm={7}
            md={7}
            style={{
              display: "flex",
              pointerEvents: disableEvents ? "none" : "auto",
            }}
            direction="row"
            alignContent="space-around"
            justify="space-around"
          >
            {/*FB 4774 DK - Modified condition*/}
            {props.Provider.schedulesByLocation[props.Index].availableSlotsCount <= 0 ? (
              <Grid item style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  {/*FB-4912 - Start*/}
                  {props.Provider.schedulesByLocation[props.Index].NextAvailability != null ?
                    (<div className={classes.timeSlotItem}>
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "center" }}
                      >
                        The next available online appointment for this provider is {props.Provider.schedulesByLocation[props.Index].NextAvailability}
                        . If you need an appointment sooner, Please call {formatphone(props.Provider.schedulesByLocation[props.Index].SchedulinPhone)}.
                      </Typography>
                    </div>) : (
                      <div className={classes.timeSlotItem}>
                        {/* FB 7418 Begin */}
                        {!textValue ? (
                          <Typography
                            variant="subtitle2"
                            style={{ textAlign: "center" }}
                          >
                            There are no online appointments available for this provider. Please call {formatphone(props.Provider.schedulesByLocation[props.Index].SchedulinPhone)} to book an appointment.
                          </Typography>)
                          :
                          <Typography
                            variant="subtitle2"
                            style={{ textAlign: "center" }}
                          >
                            {/* FB 4774 - Modified the message */}
                            {/* FB 4867 */}
                            {/* FB 8680 */}
                            {props.Provider.schedulesByLocation[props.Index].SchedulinPhone.length > 0 ? textMessage.replace("@practice_phone", props.Provider.schedulesByLocation[props.Index].SchedulinPhone)
                              : textMessage.replace("@practice_phone", defaultPhone)}
                          </Typography>
                        }
                        {/* FB 7418 End */}
                      </div>)}
                  {/*FB-4912 - End*/}
                </Grid>
              </Grid>
              // FB 4409 DK - Added condition and message to be displayed when there are no available slots - Start
            ) : props.Provider.schedulesByLocation[props.Index].availableSlotsCount <= 0 ? (
              <Grid item style={{ margin: "auto" }}>
                <Grid
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                >
                  <div className={classes.timeSlotItem}>
                    {/* FB 7418 Begin */}
                    {!textValue ? (
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "center" }}
                      >
                        {/*FB 4774 DK - Modified message*/}
                        {/*FB-4867*/} {/*FB-4912*/}
                        {props.Provider.schedulesByLocation[props.Index].NextAvailability != null ?
                          "The next available online appointment for this provider is " +
                          props.Provider.schedulesByLocation[props.Index].NextAvailability + ". If you need an appointment sooner, Please call " + formatphone(props.Provider.schedulesByLocation[props.Index].SchedulinPhone) + "."
                          :
                          "There are no online appointments available for this provider. Please call " + formatphone(props.Provider.schedulesByLocation[props.Index].SchedulinPhone) + " to book an appointment."}
                      </Typography>)
                      :
                      <Typography
                        variant="subtitle2"
                        style={{ textAlign: "center" }}
                      >
                        {/* FB 4774 - Modified the message */}
                        {/* FB 4867 */}
                        {/* FB 8680 */}
                        {props.Provider.schedulesByLocation[props.Index].SchedulinPhone.length > 0 ? textMessage.replace("@practice_phone", props.Provider.schedulesByLocation[props.Index].SchedulinPhone)
                          : textMessage.replace("@practice_phone", defaultPhone)}
                      </Typography>
                    }
                    {/* FB 7418 End */}
                  </div>
                </Grid>
              </Grid>
            ) : (
              // FB 4409 DK - Added condition and message to be displayed when there are no available slots - End
              props.Provider.schedulesByLocation[
                props.Index
              ].SlotsDate.map((ele: SlotsDate, index: number) => (
                <SlotsContainer
                  limited={props.Limited}
                  schedulesTest={ele}
                  key={index}
                  employeeName={
                    props.Provider.schedulesByLocation[props.Index]
                      .Employee_First_Name +
                    " " +
                    props.Provider.schedulesByLocation[props.Index]
                      .Employee_Last_Name
                  }
                  employeeid={
                    props.Provider.schedulesByLocation[props.Index].Employee_N
                  }
                  facilityid={props.FacilityId}
                  facilityName={props.FacilityName}
                  facilityPhone={
                    Phone === ""
                      ? ""
                      : "(" +
                      Phone.slice(0, 3) +
                      ") " +
                      Phone.slice(3, 6) +
                      "-" +
                      Phone.slice(6, 10)
                  }
                  onCallback={setDiableEvents}
                  isLoading={setIsLoading}  //FB 4409 DK - Added to update the isLoading flag on slots page
                  duration={props.Provider.schedulesByLocation[props.Index].Duration} //FB 4638 added appt duration
                />
              ))
            )}
          </Grid>
        </Grid>
      )}
    </div>
  ) : (
    <></>
  );
}

export default LocationScheduleRow;
